import {Skeleton, Stack} from "@mui/material";
import React from "react";

interface Props {
  testId: string;
}

const TextFieldSkeleton = ({
  testId
}: Props) => (
  <Stack
    width="100%"
    gap="0.8rem"
    data-testid={`${testId}_text-field-skeleton`}
  >
    <Skeleton height="2rem" width="10rem" />
    <Skeleton
      variant="rounded"
      width="100%"
      height="4.5rem"
      sx={{
        borderRadius: "1rem"
      }}
    />
  </Stack>
);

export default TextFieldSkeleton;